// @flow

/**
 * Module dependencies.
 */

import { FormGroup, Label, makeFormControl } from 'client/components/core/forms/styles';
import { compose, defaultProps } from 'recompose';
import { isFunction } from 'lodash';
import React, { Component } from 'react';

/**
 * `Props` type.
 */

type Props = {
  label: string,
  onUpdate?: Function,
  placeholder? : string,
  setValueState: Function,
  themeColor?: string,
  triggerValueState: Function,
  type?: string,
  validation?: Function,
  value?: string,
  [key: string]: any
};

/**
 * `InputFormControl` component.
 */

const InputFormControl = makeFormControl();

/**
 * `InputComponent`.
 */

class InputComponent extends Component {

  /**
   * Props.
   */

  props: Props;

  /**
   * State.
   */

  state = {
    hasError: false,
    hasFocus: false,
    hasValue: false
  };

  /**
   * Input.
   */

  input: ?Object;

  /**
   * Set `input` ref.
   */

  setInput = (input: ?Object) => {
    this.input = input;
  };

  /**
   * On Blur.
   */

  onBlur = (event: any) => {
    this.setState({
      hasFocus: false,
      hasValue: Boolean(event.currentTarget.value)
    });
  }

  /**
   * On Focus.
   */

  onFocus = (event: any) => {
    this.setState({
      hasFocus: true,
      hasValue: Boolean(event.currentTarget.value)
    });
  }

  /**
   * On Change.
   */

  onChange = (event: any) => {
    const { onUpdate, validation } = this.props;
    const targetValue = event.currentTarget.value;
    const hasError = isFunction(validation) ? !validation(targetValue) : !targetValue;

    if (isFunction(onUpdate)) {
      onUpdate(event);
    }

    this.setState({
      hasError,
      hasFocus: true,
      hasValue: Boolean(targetValue)
    });
  }

  /**
   * Component will receive props.
   */

  componentWillReceiveProps({ value }: Object) {
    if (!value) {
      return;
    }

    this.setState({
      hasValue: Boolean(value)
    });
  }

  /**
   * Render.
   */

  render(): React$Element<*> {
    const { hasFocus, hasValue, hasError } = this.state;
    const { label, themeColor, type, ...rest } = this.props;

    return (
      <FormGroup
        hasError={hasError}
        hasFocus={hasFocus}
        themeColor={themeColor}
      >
        <Label
          active={hasFocus || hasValue}
          hasError={hasError}
          hasFocus={hasFocus}
          themeColor={themeColor}
        >
          {label}
        </Label>

        <InputFormControl
          innerRef={this.setInput}
          onBlur={this.onBlur}
          onChange={this.onChange}
          onFocus={this.onFocus}
          themeColor={themeColor}
          type={type}
          {...rest}
        />
      </FormGroup>
    );
  }

}

/**
 * Export `Input`.
 */

export const Input = compose(
  defaultProps({
    type: 'text'
  })
)(InputComponent);



// WEBPACK FOOTER //
// ../src/client/components/core/forms/input.js